import { render, staticRenderFns } from "./ItemKey.vue?vue&type=template&id=764d004b"
import script from "./ItemKey.vue?vue&type=script&lang=js"
export * from "./ItemKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764d004b')) {
      api.createRecord('764d004b', component.options)
    } else {
      api.reload('764d004b', component.options)
    }
    module.hot.accept("./ItemKey.vue?vue&type=template&id=764d004b", function () {
      api.rerender('764d004b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/ItemKey.vue"
export default component.exports